import {
  asyncWithLDProvider,
  type LDOptions,
} from 'launchdarkly-react-client-sdk';

export const initializeLDProvider = async ({
  clientId,
  options,
}: {
  clientId?: string;
  options?: LDOptions;
}) => {
  try {
    if (!clientId) {
      throw new Error('LaunchDarkly client ID is required');
    }

    const LDProvider = await asyncWithLDProvider({
      options: {
        disableSyncEventPost: true,
        allAttributesPrivate: true,
        ...options,
      },
      clientSideID: clientId,
    });

    return LDProvider;
  } catch (error) {
    console.error('Failed to initialize LaunchDarkly provider', error);
    throw error;
  }
};
